var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPattern2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 500,
    viewBox: "0 0 910 910",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 454.591,
    cy: 454.591,
    r: 240.951,
    transform: "rotate(155.374 454.591 454.591)",
    fill: "url(#paint0_linear)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.852 468.274C151.32 468.274 151.699 468.653 151.699 469.121V479.28C151.699 479.748 151.32 480.127 150.852 480.127C150.385 480.127 150.006 479.748 150.006 479.28V469.121C150.006 468.653 150.385 468.274 150.852 468.274Z",
    fill: "#086ad8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.926 474.201C144.926 473.734 145.305 473.354 145.773 473.354H155.932C156.4 473.354 156.779 473.734 156.779 474.201C156.779 474.669 156.4 475.048 155.932 475.048H145.773C145.305 475.048 144.926 474.669 144.926 474.201Z",
    fill: "#086ad8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.107 491.529C174.575 491.529 174.954 491.908 174.954 492.376V502.535C174.954 503.003 174.575 503.382 174.107 503.382C173.64 503.382 173.261 503.003 173.261 502.535V492.376C173.261 491.908 173.64 491.529 174.107 491.529Z",
    fill: "#086ad8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.181 497.456C168.181 496.988 168.56 496.609 169.028 496.609H179.187C179.655 496.609 180.034 496.988 180.034 497.456C180.034 497.924 179.655 498.303 179.187 498.303H169.028C168.56 498.303 168.181 497.924 168.181 497.456Z",
    fill: "#086ad8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.363 514.785C197.83 514.785 198.209 515.164 198.209 515.632V525.791C198.209 526.259 197.83 526.638 197.363 526.638C196.895 526.638 196.516 526.259 196.516 525.791V515.632C196.516 515.164 196.895 514.785 197.363 514.785Z",
    fill: "#086ad8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.437 520.712C191.437 520.244 191.816 519.865 192.283 519.865H202.443C202.91 519.865 203.289 520.244 203.289 520.712C203.289 521.179 202.91 521.558 202.443 521.558H192.283C191.816 521.558 191.437 521.179 191.437 520.712Z",
    fill: "#086ad8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.618 538.04C221.086 538.04 221.465 538.419 221.465 538.887V549.046C221.465 549.514 221.086 549.893 220.618 549.893C220.151 549.893 219.771 549.514 219.771 549.046V538.887C219.771 538.419 220.151 538.04 220.618 538.04Z",
    fill: "#086ad8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.692 543.967C214.692 543.499 215.071 543.12 215.539 543.12H225.698C226.166 543.12 226.545 543.499 226.545 543.967C226.545 544.434 226.166 544.813 225.698 544.813H215.539C215.071 544.813 214.692 544.434 214.692 543.967Z",
    fill: "#086ad8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.873 561.295C244.341 561.295 244.72 561.674 244.72 562.142V572.301C244.72 572.769 244.341 573.148 243.873 573.148C243.405 573.148 243.026 572.769 243.026 572.301V562.142C243.026 561.674 243.405 561.295 243.873 561.295Z",
    fill: "#086ad8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.947 567.222C237.947 566.754 238.326 566.375 238.793 566.375H248.953C249.42 566.375 249.799 566.754 249.799 567.222C249.799 567.689 249.42 568.068 248.953 568.068H238.793C238.326 568.068 237.947 567.689 237.947 567.222Z",
    fill: "#086ad8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M267.128 584.55C267.595 584.55 267.974 584.929 267.974 585.396V595.556C267.974 596.023 267.595 596.403 267.128 596.403C266.66 596.403 266.281 596.023 266.281 595.556V585.396C266.281 584.929 266.66 584.55 267.128 584.55Z",
    fill: "#086ad8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.202 590.477C261.202 590.009 261.581 589.63 262.048 589.63H272.208C272.675 589.63 273.054 590.009 273.054 590.477C273.054 590.944 272.675 591.323 272.208 591.323H262.048C261.581 591.323 261.202 590.944 261.202 590.477Z",
    fill: "#086ad8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.854 445.779C174.322 445.779 174.701 446.158 174.701 446.626V456.785C174.701 457.253 174.322 457.632 173.854 457.632C173.387 457.632 173.008 457.253 173.008 456.785V446.626C173.008 446.158 173.387 445.779 173.854 445.779Z",
    fill: "#086ad8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.928 451.706C167.928 451.238 168.307 450.859 168.775 450.859H178.934C179.402 450.859 179.781 451.238 179.781 451.706C179.781 452.174 179.402 452.553 178.934 452.553H168.775C168.307 452.553 167.928 452.174 167.928 451.706Z",
    fill: "#086ad8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.11 469.034C197.577 469.034 197.956 469.413 197.956 469.881V480.04C197.956 480.508 197.577 480.887 197.11 480.887C196.642 480.887 196.263 480.508 196.263 480.04V469.881C196.263 469.413 196.642 469.034 197.11 469.034Z",
    fill: "#086ad8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.184 474.961C191.184 474.493 191.563 474.114 192.03 474.114H202.19C202.657 474.114 203.036 474.493 203.036 474.961C203.036 475.428 202.657 475.808 202.19 475.808H192.03C191.563 475.808 191.184 475.428 191.184 474.961Z",
    fill: "#086ad8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.365 492.289C220.832 492.289 221.211 492.668 221.211 493.136V503.295C221.211 503.763 220.832 504.142 220.365 504.142C219.897 504.142 219.518 503.763 219.518 503.295V493.136C219.518 492.668 219.897 492.289 220.365 492.289Z",
    fill: "#086ad8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.438 498.216C214.438 497.748 214.818 497.369 215.285 497.369H225.445C225.912 497.369 226.291 497.748 226.291 498.216C226.291 498.683 225.912 499.062 225.445 499.062H215.285C214.818 499.062 214.438 498.683 214.438 498.216Z",
    fill: "#086ad8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.62 515.544C244.087 515.544 244.466 515.923 244.466 516.391V526.55C244.466 527.018 244.087 527.397 243.62 527.397C243.152 527.397 242.773 527.018 242.773 526.55V516.391C242.773 515.923 243.152 515.544 243.62 515.544Z",
    fill: "#086ad8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.693 521.471C237.693 521.003 238.072 520.624 238.54 520.624H248.699C249.167 520.624 249.546 521.003 249.546 521.471C249.546 521.938 249.167 522.317 248.699 522.317H238.54C238.072 522.317 237.693 521.938 237.693 521.471Z",
    fill: "#086ad8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.874 538.799C267.342 538.799 267.721 539.178 267.721 539.645V549.805C267.721 550.272 267.342 550.652 266.874 550.652C266.407 550.652 266.028 550.272 266.028 549.805V539.645C266.028 539.178 266.407 538.799 266.874 538.799Z",
    fill: "#086ad8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M260.948 544.726C260.948 544.258 261.327 543.879 261.795 543.879H271.954C272.422 543.879 272.801 544.258 272.801 544.726C272.801 545.193 272.422 545.572 271.954 545.572H261.795C261.327 545.572 260.948 545.193 260.948 544.726Z",
    fill: "#086ad8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.13 562.055C290.597 562.055 290.976 562.434 290.976 562.901V573.061C290.976 573.528 290.597 573.907 290.13 573.907C289.662 573.907 289.283 573.528 289.283 573.061V562.901C289.283 562.434 289.662 562.055 290.13 562.055Z",
    fill: "#086ad8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.204 567.981C284.204 567.514 284.583 567.135 285.05 567.135H295.21C295.677 567.135 296.056 567.514 296.056 567.981C296.056 568.449 295.677 568.828 295.21 568.828H285.05C284.583 568.828 284.204 568.449 284.204 567.981Z",
    fill: "#086ad8"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.603 423.03C197.071 423.03 197.45 423.409 197.45 423.877V434.036C197.45 434.504 197.071 434.883 196.603 434.883C196.136 434.883 195.757 434.504 195.757 434.036V423.877C195.757 423.409 196.136 423.03 196.603 423.03Z",
    fill: "#086ad8"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.677 428.957C190.677 428.489 191.056 428.11 191.524 428.11H201.683C202.151 428.11 202.53 428.489 202.53 428.957C202.53 429.425 202.151 429.804 201.683 429.804H191.524C191.056 429.804 190.677 429.425 190.677 428.957Z",
    fill: "#086ad8"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.858 446.285C220.326 446.285 220.705 446.664 220.705 447.132V457.291C220.705 457.759 220.326 458.138 219.858 458.138C219.391 458.138 219.012 457.759 219.012 457.291V447.132C219.012 446.664 219.391 446.285 219.858 446.285Z",
    fill: "#086ad8"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.932 452.212C213.932 451.744 214.311 451.365 214.779 451.365H224.938C225.406 451.365 225.785 451.744 225.785 452.212C225.785 452.679 225.406 453.058 224.938 453.058H214.779C214.311 453.058 213.932 452.679 213.932 452.212Z",
    fill: "#086ad8"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.113 469.54C243.581 469.54 243.96 469.919 243.96 470.387V480.546C243.96 481.014 243.581 481.393 243.113 481.393C242.646 481.393 242.267 481.014 242.267 480.546V470.387C242.267 469.919 242.646 469.54 243.113 469.54Z",
    fill: "#086ad8"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.187 475.467C237.187 474.999 237.566 474.62 238.034 474.62H248.193C248.661 474.62 249.04 474.999 249.04 475.467C249.04 475.934 248.661 476.313 248.193 476.313H238.034C237.566 476.313 237.187 475.934 237.187 475.467Z",
    fill: "#086ad8"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.369 492.796C266.836 492.796 267.215 493.175 267.215 493.643V503.802C267.215 504.27 266.836 504.649 266.369 504.649C265.901 504.649 265.522 504.27 265.522 503.802V493.643C265.522 493.175 265.901 492.796 266.369 492.796Z",
    fill: "#086ad8"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M260.442 498.723C260.442 498.255 260.821 497.876 261.289 497.876H271.448C271.916 497.876 272.295 498.255 272.295 498.723C272.295 499.19 271.916 499.569 271.448 499.569H261.289C260.821 499.569 260.442 499.19 260.442 498.723Z",
    fill: "#086ad8"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289.624 516.051C290.092 516.051 290.471 516.43 290.471 516.897V527.057C290.471 527.524 290.092 527.903 289.624 527.903C289.156 527.903 288.777 527.524 288.777 527.057V516.897C288.777 516.43 289.156 516.051 289.624 516.051Z",
    fill: "#086ad8"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M283.698 521.977C283.698 521.51 284.077 521.131 284.544 521.131H294.704C295.171 521.131 295.55 521.51 295.55 521.977C295.55 522.445 295.171 522.824 294.704 522.824H284.544C284.077 522.824 283.698 522.445 283.698 521.977Z",
    fill: "#086ad8"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M312.879 539.306C313.346 539.306 313.725 539.685 313.725 540.152V550.312C313.725 550.779 313.346 551.158 312.879 551.158C312.411 551.158 312.032 550.779 312.032 550.312V540.152C312.032 539.685 312.411 539.306 312.879 539.306Z",
    fill: "#086ad8"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M306.953 545.232C306.953 544.765 307.332 544.386 307.799 544.386H317.959C318.426 544.386 318.805 544.765 318.805 545.232C318.805 545.7 318.426 546.079 317.959 546.079H307.799C307.332 546.079 306.953 545.7 306.953 545.232Z",
    fill: "#086ad8"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.352 400.281C219.82 400.281 220.199 400.66 220.199 401.128V411.287C220.199 411.755 219.82 412.134 219.352 412.134C218.884 412.134 218.505 411.755 218.505 411.287V401.128C218.505 400.66 218.884 400.281 219.352 400.281Z",
    fill: "#086ad8"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.426 406.208C213.426 405.74 213.805 405.361 214.272 405.361H224.432C224.899 405.361 225.278 405.74 225.278 406.208C225.278 406.676 224.899 407.055 224.432 407.055H214.272C213.805 407.055 213.426 406.676 213.426 406.208Z",
    fill: "#086ad8"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.607 423.536C243.075 423.536 243.454 423.915 243.454 424.383V434.542C243.454 435.01 243.075 435.389 242.607 435.389C242.14 435.389 241.761 435.01 241.761 434.542V424.383C241.761 423.915 242.14 423.536 242.607 423.536Z",
    fill: "#086ad8"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.681 429.463C236.681 428.995 237.06 428.616 237.528 428.616H247.687C248.155 428.616 248.534 428.995 248.534 429.463C248.534 429.93 248.155 430.309 247.687 430.309H237.528C237.06 430.309 236.681 429.93 236.681 429.463Z",
    fill: "#086ad8"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.862 446.792C266.33 446.792 266.709 447.171 266.709 447.639V457.798C266.709 458.266 266.33 458.645 265.862 458.645C265.395 458.645 265.016 458.266 265.016 457.798V447.639C265.016 447.171 265.395 446.792 265.862 446.792Z",
    fill: "#086ad8"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M259.936 452.719C259.936 452.251 260.315 451.872 260.783 451.872H270.942C271.41 451.872 271.789 452.251 271.789 452.719C271.789 453.186 271.41 453.565 270.942 453.565H260.783C260.315 453.565 259.936 453.186 259.936 452.719Z",
    fill: "#086ad8"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289.118 470.047C289.585 470.047 289.964 470.426 289.964 470.893V481.053C289.964 481.521 289.585 481.9 289.118 481.9C288.65 481.9 288.271 481.521 288.271 481.053V470.893C288.271 470.426 288.65 470.047 289.118 470.047Z",
    fill: "#086ad8"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M283.191 475.974C283.191 475.506 283.57 475.127 284.038 475.127H294.197C294.665 475.127 295.044 475.506 295.044 475.974C295.044 476.441 294.665 476.82 294.197 476.82H284.038C283.57 476.82 283.191 476.441 283.191 475.974Z",
    fill: "#086ad8"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M312.373 493.302C312.84 493.302 313.219 493.681 313.219 494.148V504.308C313.219 504.775 312.84 505.154 312.373 505.154C311.905 505.154 311.526 504.775 311.526 504.308V494.148C311.526 493.681 311.905 493.302 312.373 493.302Z",
    fill: "#086ad8"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M306.446 499.228C306.446 498.761 306.825 498.382 307.293 498.382H317.452C317.92 498.382 318.299 498.761 318.299 499.228C318.299 499.696 317.92 500.075 317.452 500.075H307.293C306.825 500.075 306.446 499.696 306.446 499.228Z",
    fill: "#086ad8"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M335.627 516.557C336.095 516.557 336.474 516.936 336.474 517.403V527.563C336.474 528.03 336.095 528.409 335.627 528.409C335.16 528.409 334.781 528.03 334.781 527.563V517.403C334.781 516.936 335.16 516.557 335.627 516.557Z",
    fill: "#086ad8"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M329.701 522.483C329.701 522.016 330.08 521.637 330.548 521.637H340.707C341.175 521.637 341.554 522.016 341.554 522.483C341.554 522.951 341.175 523.33 340.707 523.33H330.548C330.08 523.33 329.701 522.951 329.701 522.483Z",
    fill: "#086ad8"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.101 377.533C242.569 377.533 242.948 377.912 242.948 378.38V388.539C242.948 389.007 242.569 389.386 242.101 389.386C241.633 389.386 241.254 389.007 241.254 388.539V378.38C241.254 377.912 241.633 377.533 242.101 377.533Z",
    fill: "#086ad8"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.175 383.46C236.175 382.992 236.554 382.613 237.021 382.613H247.181C247.648 382.613 248.028 382.992 248.028 383.46C248.028 383.927 247.648 384.307 247.181 384.307H237.021C236.554 384.307 236.175 383.927 236.175 383.46Z",
    fill: "#086ad8"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.356 400.788C265.824 400.788 266.203 401.167 266.203 401.635V411.794C266.203 412.262 265.824 412.641 265.356 412.641C264.889 412.641 264.51 412.262 264.51 411.794V401.635C264.51 401.167 264.889 400.788 265.356 400.788Z",
    fill: "#086ad8"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M259.43 406.715C259.43 406.247 259.809 405.868 260.277 405.868H270.436C270.904 405.868 271.283 406.247 271.283 406.715C271.283 407.182 270.904 407.561 270.436 407.561H260.277C259.809 407.561 259.43 407.182 259.43 406.715Z",
    fill: "#086ad8"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M288.611 424.043C289.079 424.043 289.458 424.422 289.458 424.89V435.049C289.458 435.517 289.079 435.896 288.611 435.896C288.144 435.896 287.765 435.517 287.765 435.049V424.89C287.765 424.422 288.144 424.043 288.611 424.043Z",
    fill: "#086ad8"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282.685 429.97C282.685 429.502 283.064 429.123 283.532 429.123H293.691C294.159 429.123 294.538 429.502 294.538 429.97C294.538 430.437 294.159 430.816 293.691 430.816H283.532C283.064 430.816 282.685 430.437 282.685 429.97Z",
    fill: "#086ad8"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M311.866 447.298C312.334 447.298 312.713 447.677 312.713 448.144V458.304C312.713 458.772 312.334 459.151 311.866 459.151C311.399 459.151 311.02 458.772 311.02 458.304V448.144C311.02 447.677 311.399 447.298 311.866 447.298Z",
    fill: "#086ad8"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M305.94 453.225C305.94 452.757 306.319 452.378 306.787 452.378H316.946C317.414 452.378 317.793 452.757 317.793 453.225C317.793 453.692 317.414 454.071 316.946 454.071H306.787C306.319 454.071 305.94 453.692 305.94 453.225Z",
    fill: "#086ad8"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M335.121 470.553C335.589 470.553 335.968 470.932 335.968 471.399V481.559C335.968 482.026 335.589 482.405 335.121 482.405C334.653 482.405 334.274 482.026 334.274 481.559V471.399C334.274 470.932 334.653 470.553 335.121 470.553Z",
    fill: "#086ad8"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M329.195 476.479C329.195 476.012 329.574 475.633 330.041 475.633H340.201C340.668 475.633 341.048 476.012 341.048 476.479C341.048 476.947 340.668 477.326 340.201 477.326H330.041C329.574 477.326 329.195 476.947 329.195 476.479Z",
    fill: "#086ad8"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M358.376 493.808C358.844 493.808 359.223 494.187 359.223 494.654V504.814C359.223 505.281 358.844 505.66 358.376 505.66C357.909 505.66 357.53 505.281 357.53 504.814V494.654C357.53 494.187 357.909 493.808 358.376 493.808Z",
    fill: "#086ad8"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M352.45 499.734C352.45 499.267 352.829 498.888 353.297 498.888H363.456C363.924 498.888 364.303 499.267 364.303 499.734C364.303 500.202 363.924 500.581 363.456 500.581H353.297C352.829 500.581 352.45 500.202 352.45 499.734Z",
    fill: "#086ad8"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264.85 354.784C265.318 354.784 265.697 355.163 265.697 355.631V365.79C265.697 366.258 265.318 366.637 264.85 366.637C264.382 366.637 264.003 366.258 264.003 365.79V355.631C264.003 355.163 264.382 354.784 264.85 354.784Z",
    fill: "#086ad8"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258.924 360.711C258.924 360.243 259.303 359.864 259.77 359.864H269.93C270.397 359.864 270.777 360.243 270.777 360.711C270.777 361.178 270.397 361.558 269.93 361.558H259.77C259.303 361.558 258.924 361.178 258.924 360.711Z",
    fill: "#086ad8"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M288.104 378.039C288.572 378.039 288.951 378.418 288.951 378.886V389.045C288.951 389.513 288.572 389.892 288.104 389.892C287.637 389.892 287.258 389.513 287.258 389.045V378.886C287.258 378.418 287.637 378.039 288.104 378.039Z",
    fill: "#086ad8"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282.178 383.966C282.178 383.498 282.557 383.119 283.025 383.119H293.184C293.652 383.119 294.031 383.498 294.031 383.966C294.031 384.433 293.652 384.812 293.184 384.812H283.025C282.557 384.812 282.178 384.433 282.178 383.966Z",
    fill: "#086ad8"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M311.36 401.294C311.827 401.294 312.206 401.673 312.206 402.141V412.3C312.206 412.768 311.827 413.147 311.36 413.147C310.892 413.147 310.513 412.768 310.513 412.3V402.141C310.513 401.673 310.892 401.294 311.36 401.294Z",
    fill: "#086ad8"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M305.434 407.221C305.434 406.753 305.813 406.374 306.28 406.374H316.44C316.907 406.374 317.286 406.753 317.286 407.221C317.286 407.688 316.907 408.067 316.44 408.067H306.28C305.813 408.067 305.434 407.688 305.434 407.221Z",
    fill: "#086ad8"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M334.615 424.549C335.083 424.549 335.462 424.928 335.462 425.395V435.555C335.462 436.022 335.083 436.402 334.615 436.402C334.148 436.402 333.769 436.022 333.769 435.555V425.395C333.769 424.928 334.148 424.549 334.615 424.549Z",
    fill: "#086ad8"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.689 430.476C328.689 430.008 329.068 429.629 329.536 429.629H339.695C340.163 429.629 340.542 430.008 340.542 430.476C340.542 430.943 340.163 431.322 339.695 431.322H329.536C329.068 431.322 328.689 430.943 328.689 430.476Z",
    fill: "#086ad8"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M357.87 447.804C358.338 447.804 358.717 448.183 358.717 448.65V458.81C358.717 459.277 358.338 459.656 357.87 459.656C357.402 459.656 357.023 459.277 357.023 458.81V448.65C357.023 448.183 357.402 447.804 357.87 447.804Z",
    fill: "#086ad8"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M351.944 453.73C351.944 453.263 352.323 452.884 352.79 452.884H362.95C363.418 452.884 363.797 453.263 363.797 453.73C363.797 454.198 363.418 454.577 362.95 454.577H352.79C352.323 454.577 351.944 454.198 351.944 453.73Z",
    fill: "#086ad8"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M381.125 471.06C381.593 471.06 381.972 471.439 381.972 471.906V482.066C381.972 482.533 381.593 482.912 381.125 482.912C380.657 482.912 380.278 482.533 380.278 482.066V471.906C380.278 471.439 380.657 471.06 381.125 471.06Z",
    fill: "#086ad8"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M375.199 476.986C375.199 476.519 375.578 476.14 376.045 476.14H386.205C386.672 476.14 387.051 476.519 387.051 476.986C387.051 477.454 386.672 477.833 386.205 477.833H376.045C375.578 477.833 375.199 477.454 375.199 476.986Z",
    fill: "#086ad8"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M287.852 332.288C288.319 332.288 288.698 332.667 288.698 333.135V343.294C288.698 343.762 288.319 344.141 287.852 344.141C287.384 344.141 287.005 343.762 287.005 343.294V333.135C287.005 332.667 287.384 332.288 287.852 332.288Z",
    fill: "#086ad8"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M281.925 338.215C281.925 337.747 282.304 337.368 282.772 337.368H292.931C293.399 337.368 293.778 337.747 293.778 338.215C293.778 338.682 293.399 339.061 292.931 339.061H282.772C282.304 339.061 281.925 338.682 281.925 338.215Z",
    fill: "#086ad8"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M311.107 355.543C311.574 355.543 311.953 355.922 311.953 356.39V366.549C311.953 367.017 311.574 367.396 311.107 367.396C310.639 367.396 310.26 367.017 310.26 366.549V356.39C310.26 355.922 310.639 355.543 311.107 355.543Z",
    fill: "#086ad8"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M305.181 361.47C305.181 361.002 305.56 360.623 306.027 360.623H316.187C316.654 360.623 317.033 361.002 317.033 361.47C317.033 361.937 316.654 362.316 316.187 362.316H306.027C305.56 362.316 305.181 361.937 305.181 361.47Z",
    fill: "#086ad8"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M334.362 378.799C334.829 378.799 335.208 379.178 335.208 379.645V389.805C335.208 390.272 334.829 390.652 334.362 390.652C333.894 390.652 333.515 390.272 333.515 389.805V379.645C333.515 379.178 333.894 378.799 334.362 378.799Z",
    fill: "#086ad8"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.436 384.726C328.436 384.258 328.815 383.879 329.282 383.879H339.442C339.909 383.879 340.288 384.258 340.288 384.726C340.288 385.193 339.909 385.572 339.442 385.572H329.282C328.815 385.572 328.436 385.193 328.436 384.726Z",
    fill: "#086ad8"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M357.617 402.054C358.085 402.054 358.464 402.433 358.464 402.9V413.06C358.464 413.527 358.085 413.906 357.617 413.906C357.15 413.906 356.771 413.527 356.771 413.06V402.9C356.771 402.433 357.15 402.054 357.617 402.054Z",
    fill: "#086ad8"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M351.691 407.98C351.691 407.513 352.07 407.134 352.538 407.134H362.697C363.165 407.134 363.544 407.513 363.544 407.98C363.544 408.448 363.165 408.827 362.697 408.827H352.538C352.07 408.827 351.691 408.448 351.691 407.98Z",
    fill: "#086ad8"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M380.872 425.309C381.339 425.309 381.718 425.688 381.718 426.155V436.315C381.718 436.782 381.339 437.161 380.872 437.161C380.404 437.161 380.025 436.782 380.025 436.315V426.155C380.025 425.688 380.404 425.309 380.872 425.309Z",
    fill: "#086ad8"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.945 431.235C374.945 430.768 375.324 430.389 375.792 430.389H385.951C386.419 430.389 386.798 430.768 386.798 431.235C386.798 431.703 386.419 432.082 385.951 432.082H375.792C375.324 432.082 374.945 431.703 374.945 431.235Z",
    fill: "#086ad8"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M404.127 448.563C404.594 448.563 404.974 448.943 404.974 449.41V459.57C404.974 460.037 404.594 460.416 404.127 460.416C403.659 460.416 403.28 460.037 403.28 459.57V449.41C403.28 448.943 403.659 448.563 404.127 448.563Z",
    fill: "#086ad8"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M398.201 454.49C398.201 454.023 398.58 453.644 399.047 453.644H409.207C409.674 453.644 410.053 454.023 410.053 454.49C410.053 454.958 409.674 455.337 409.207 455.337H399.047C398.58 455.337 398.201 454.958 398.201 454.49Z",
    fill: "#086ad8"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M310.601 309.539C311.068 309.539 311.447 309.918 311.447 310.386V320.545C311.447 321.013 311.068 321.392 310.601 321.392C310.133 321.392 309.754 321.013 309.754 320.545V310.386C309.754 309.918 310.133 309.539 310.601 309.539Z",
    fill: "#086ad8"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.674 315.466C304.674 314.998 305.053 314.619 305.521 314.619H315.68C316.148 314.619 316.527 314.998 316.527 315.466C316.527 315.933 316.148 316.312 315.68 316.312H305.521C305.053 316.312 304.674 315.933 304.674 315.466Z",
    fill: "#086ad8"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M333.856 332.795C334.323 332.795 334.703 333.174 334.703 333.642V343.801C334.703 344.269 334.323 344.648 333.856 344.648C333.388 344.648 333.009 344.269 333.009 343.801V333.642C333.009 333.174 333.388 332.795 333.856 332.795Z",
    fill: "#086ad8"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M327.93 338.722C327.93 338.254 328.309 337.875 328.776 337.875H338.936C339.403 337.875 339.782 338.254 339.782 338.722C339.782 339.189 339.403 339.568 338.936 339.568H328.776C328.309 339.568 327.93 339.189 327.93 338.722Z",
    fill: "#086ad8"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M357.11 356.05C357.578 356.05 357.957 356.429 357.957 356.896V367.056C357.957 367.523 357.578 367.903 357.11 367.903C356.643 367.903 356.264 367.523 356.264 367.056V356.896C356.264 356.429 356.643 356.05 357.11 356.05Z",
    fill: "#086ad8"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M351.184 361.977C351.184 361.509 351.563 361.13 352.031 361.13H362.19C362.658 361.13 363.037 361.509 363.037 361.977C363.037 362.444 362.658 362.823 362.19 362.823H352.031C351.563 362.823 351.184 362.444 351.184 361.977Z",
    fill: "#086ad8"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M380.366 379.305C380.833 379.305 381.212 379.684 381.212 380.151V390.311C381.212 390.778 380.833 391.157 380.366 391.157C379.898 391.157 379.519 390.778 379.519 390.311V380.151C379.519 379.684 379.898 379.305 380.366 379.305Z",
    fill: "#086ad8"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.439 385.231C374.439 384.764 374.818 384.385 375.286 384.385H385.446C385.913 384.385 386.292 384.764 386.292 385.231C386.292 385.699 385.913 386.078 385.446 386.078H375.286C374.818 386.078 374.439 385.699 374.439 385.231Z",
    fill: "#086ad8"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M403.621 402.56C404.088 402.56 404.467 402.939 404.467 403.406V413.566C404.467 414.033 404.088 414.412 403.621 414.412C403.153 414.412 402.774 414.033 402.774 413.566V403.406C402.774 402.939 403.153 402.56 403.621 402.56Z",
    fill: "#086ad8"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M397.694 408.486C397.694 408.019 398.073 407.64 398.541 407.64H408.7C409.168 407.64 409.547 408.019 409.547 408.486C409.547 408.954 409.168 409.333 408.7 409.333H398.541C398.073 409.333 397.694 408.954 397.694 408.486Z",
    fill: "#086ad8"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M426.876 425.814C427.343 425.814 427.723 426.193 427.723 426.661V436.821C427.723 437.288 427.343 437.667 426.876 437.667C426.408 437.667 426.029 437.288 426.029 436.821V426.661C426.029 426.193 426.408 425.814 426.876 425.814Z",
    fill: "#086ad8"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M420.95 431.741C420.95 431.274 421.329 430.895 421.796 430.895H431.956C432.423 430.895 432.802 431.274 432.802 431.741C432.802 432.209 432.423 432.588 431.956 432.588H421.796C421.329 432.588 420.95 432.209 420.95 431.741Z",
    fill: "#086ad8"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M333.349 286.791C333.817 286.791 334.196 287.17 334.196 287.638V297.797C334.196 298.265 333.817 298.644 333.349 298.644C332.881 298.644 332.502 298.265 332.502 297.797V287.638C332.502 287.17 332.881 286.791 333.349 286.791Z",
    fill: "#086ad8"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M327.423 292.718C327.423 292.25 327.802 291.871 328.269 291.871H338.429C338.897 291.871 339.276 292.25 339.276 292.718C339.276 293.185 338.897 293.564 338.429 293.564H328.269C327.802 293.564 327.423 293.185 327.423 292.718Z",
    fill: "#086ad8"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M356.604 310.046C357.072 310.046 357.451 310.425 357.451 310.893V321.052C357.451 321.52 357.072 321.899 356.604 321.899C356.136 321.899 355.757 321.52 355.757 321.052V310.893C355.757 310.425 356.136 310.046 356.604 310.046Z",
    fill: "#086ad8"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M350.678 315.973C350.678 315.505 351.057 315.126 351.524 315.126H361.684C362.151 315.126 362.53 315.505 362.53 315.973C362.53 316.44 362.151 316.819 361.684 316.819H351.524C351.057 316.819 350.678 316.44 350.678 315.973Z",
    fill: "#086ad8"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M379.859 333.301C380.327 333.301 380.706 333.68 380.706 334.147V344.307C380.706 344.774 380.327 345.153 379.859 345.153C379.392 345.153 379.013 344.774 379.013 344.307V334.147C379.013 333.68 379.392 333.301 379.859 333.301Z",
    fill: "#086ad8"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M373.933 339.227C373.933 338.76 374.312 338.381 374.78 338.381H384.939C385.407 338.381 385.786 338.76 385.786 339.227C385.786 339.695 385.407 340.074 384.939 340.074H374.78C374.312 340.074 373.933 339.695 373.933 339.227Z",
    fill: "#086ad8"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M403.115 356.556C403.582 356.556 403.961 356.935 403.961 357.402V367.562C403.961 368.029 403.582 368.408 403.115 368.408C402.647 368.408 402.268 368.029 402.268 367.562V357.402C402.268 356.935 402.647 356.556 403.115 356.556Z",
    fill: "#086ad8"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M397.188 362.482C397.188 362.015 397.568 361.636 398.035 361.636H408.195C408.662 361.636 409.041 362.015 409.041 362.482C409.041 362.95 408.662 363.329 408.195 363.329H398.035C397.568 363.329 397.188 362.95 397.188 362.482Z",
    fill: "#086ad8"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M426.37 379.811C426.837 379.811 427.216 380.19 427.216 380.657V390.817C427.216 391.284 426.837 391.663 426.37 391.663C425.902 391.663 425.523 391.284 425.523 390.817V380.657C425.523 380.19 425.902 379.811 426.37 379.811Z",
    fill: "#086ad8"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M420.443 385.737C420.443 385.27 420.822 384.891 421.29 384.891H431.449C431.917 384.891 432.296 385.27 432.296 385.737C432.296 386.205 431.917 386.584 431.449 386.584H421.29C420.822 386.584 420.443 386.205 420.443 385.737Z",
    fill: "#086ad8"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M449.624 403.066C450.092 403.066 450.471 403.445 450.471 403.913V414.072C450.471 414.54 450.092 414.919 449.624 414.919C449.157 414.919 448.778 414.54 448.778 414.072V403.913C448.778 403.445 449.157 403.066 449.624 403.066Z",
    fill: "#086ad8"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M443.698 408.993C443.698 408.526 444.077 408.146 444.545 408.146H454.704C455.172 408.146 455.551 408.526 455.551 408.993C455.551 409.461 455.172 409.84 454.704 409.84H444.545C444.077 409.84 443.698 409.461 443.698 408.993Z",
    fill: "#086ad8"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M356.098 264.042C356.566 264.042 356.945 264.421 356.945 264.889V275.048C356.945 275.516 356.566 275.895 356.098 275.895C355.631 275.895 355.251 275.516 355.251 275.048V264.889C355.251 264.421 355.631 264.042 356.098 264.042Z",
    fill: "#086ad8"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M350.172 269.969C350.172 269.501 350.551 269.122 351.018 269.122H361.178C361.646 269.122 362.025 269.501 362.025 269.969C362.025 270.436 361.646 270.815 361.178 270.815H351.018C350.551 270.815 350.172 270.436 350.172 269.969Z",
    fill: "#086ad8"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M379.353 287.297C379.821 287.297 380.2 287.676 380.2 288.143V298.303C380.2 298.771 379.821 299.15 379.353 299.15C378.885 299.15 378.506 298.771 378.506 298.303V288.143C378.506 287.676 378.885 287.297 379.353 287.297Z",
    fill: "#086ad8"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M373.427 293.224C373.427 292.756 373.806 292.377 374.273 292.377H384.433C384.9 292.377 385.279 292.756 385.279 293.224C385.279 293.691 384.9 294.07 384.433 294.07H374.273C373.806 294.07 373.427 293.691 373.427 293.224Z",
    fill: "#086ad8"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M402.608 310.552C403.076 310.552 403.455 310.931 403.455 311.398V321.558C403.455 322.025 403.076 322.404 402.608 322.404C402.141 322.404 401.762 322.025 401.762 321.558V311.398C401.762 310.931 402.141 310.552 402.608 310.552Z",
    fill: "#086ad8"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M396.682 316.478C396.682 316.011 397.061 315.632 397.529 315.632H407.688C408.156 315.632 408.535 316.011 408.535 316.478C408.535 316.946 408.156 317.325 407.688 317.325H397.529C397.061 317.325 396.682 316.946 396.682 316.478Z",
    fill: "#086ad8"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M425.863 333.807C426.331 333.807 426.71 334.186 426.71 334.653V344.813C426.71 345.28 426.331 345.659 425.863 345.659C425.396 345.659 425.017 345.28 425.017 344.813V334.653C425.017 334.186 425.396 333.807 425.863 333.807Z",
    fill: "#086ad8"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M419.937 339.733C419.937 339.266 420.316 338.887 420.784 338.887H430.943C431.411 338.887 431.79 339.266 431.79 339.733C431.79 340.201 431.411 340.58 430.943 340.58H420.784C420.316 340.58 419.937 340.201 419.937 339.733Z",
    fill: "#086ad8"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M449.118 357.062C449.586 357.062 449.965 357.442 449.965 357.909V368.069C449.965 368.536 449.586 368.915 449.118 368.915C448.651 368.915 448.271 368.536 448.271 368.069V357.909C448.271 357.442 448.651 357.062 449.118 357.062Z",
    fill: "#086ad8"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M443.192 362.989C443.192 362.522 443.571 362.143 444.039 362.143H454.198C454.666 362.143 455.045 362.522 455.045 362.989C455.045 363.457 454.666 363.836 454.198 363.836H444.039C443.571 363.836 443.192 363.457 443.192 362.989Z",
    fill: "#086ad8"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M472.373 380.317C472.841 380.317 473.22 380.696 473.22 381.164V391.323C473.22 391.791 472.841 392.17 472.373 392.17C471.905 392.17 471.526 391.791 471.526 391.323V381.164C471.526 380.696 471.905 380.317 472.373 380.317Z",
    fill: "#086ad8"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M466.447 386.244C466.447 385.777 466.826 385.397 467.293 385.397H477.453C477.92 385.397 478.299 385.777 478.299 386.244C478.299 386.712 477.92 387.091 477.453 387.091H467.293C466.826 387.091 466.447 386.712 466.447 386.244Z",
    fill: "#086ad8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 454.591,
    y1: 213.639,
    x2: 454.591,
    y2: 634.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6D9F7",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.591667,
    stopColor: "#C4E1F2",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9875,
    stopColor: "#F2FAFF",
    stopOpacity: 0.23
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern2);
export default __webpack_public_path__ + "static/media/pattern2.1934b24faa52479dd0a615f82edd8b47.svg";
export { ForwardRef as ReactComponent };